

//reader.result // → returns something like: "data:image/png;base64,iVBORw0KGgoAAAANS..."
//reader.result.split(',')[1] // → returns something like: "iVBORw0KGgoAAAANS..."
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(',')[1]); // solo el contenido Base64
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};
